import AssignmentPanelFlow from './AssignmentPanelFlow';

export default { AssignmentPanelFlow };
